import React from "react";
import { AppWindow, Camera, Facebook, Globe } from "lucide-react";
import { Translate } from "components/common/Translate/Translate";
import {
    Section8UseCaseScaffold,
    ISection8UseCase,
} from "components/features/CompressorCommon/Section8UseCaseScaffold";

const bestUseList: ISection8UseCase[] = [
    {
        title: "developers-and-designers-heading",
        subTitle: "developers-and-designers-sub-heading",
        icon: <Globe strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "photographers-heading",
        subTitle: "photographers-sub-heading",
        icon: <Camera strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "social-media-users-heading",
        subTitle: "social-media-users-sub-heading",
        icon: <Facebook strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "app-developers-heading",
        subTitle: "app-developers-sub-heading",
        icon: <AppWindow />,
    },
];
const JpegCompressorForEveryOne = () => {
    return (
        <Section8UseCaseScaffold
            title={<Translate keyName="jpeg-compressor-is-for-everyone-title" />}
            useCases={bestUseList}
        />
    );
};

export default JpegCompressorForEveryOne;
